import axios from 'axios'
import store from '../store/index.js'
import router from '../router'
import 'ant-design-vue/dist/antd.less'
import { message } from 'ant-design-vue'

// const baseURL = 'https://server.e-snails.com/'
const baseURL = process.env.VUE_APP_BaseUrl

let loadingCount = 0

axios.interceptors.request.use(config => {
  // let urlList = config.url.split('/')
  // let url = urlList[urlList.length - 1]
  // const token = store.state.access_token
  // config.headers.Authorization = token
  // if (url == 'authentication') {
  //     return config
  // } else {
  //     config.headers.Authorization = 'Bearer ' + token
  // }
  addLoading()
  return config
}, error => {
  loadingCount = 0
  setTimeout(() => {
    store.dispatch('setLoadingState', false)
  }, 10000)
  return Promise.reject(error)
})

axios.interceptors.response.use(response => {
  closeLoading()
  return response
}, error => {
  loadingCount = 0
  store.dispatch('setLoadingState', false)
  return Promise.resolve(error.response)
})

function checkStatus (response) {
  // loading
  // 如果http状态码正常，则直接返回数据
  if (response && (response.status === 200 || response.status === 304 || response.status === 400 || response.status === '9')) {
    return response
    // 如果不需要除了data之外的数据，可以直接 return response.data
  }
  // 异常状态下，把错误信息返回去
  return {
    status: -404,
    msg: '重新登录'
  }
}

function checkCode (res) {
  // 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
  console.log('封装的请求返回', res)
  // if (res.status === -404) {
  //     alert(res.msg)
  // }
  if (res.data && (!res.data.success)) {
    alert(res.data.resultMsg + '需要重新登录')
    router.push({ name: 'login' })
  }
  return res
}
export default {
  post (url, param) {
    // 检查并获取本地存储中的 access_token 和 userId
    const userId = window.localStorage.getItem('userId')
    // 将 access_token 和 userId 添加到 params 对象中
    if (userId && (param.userId === null || param.userId === undefined || param.userId === '')) {
      param.userId = userId
    }
    // if (!param.userId) {
    //   param.userId = userId
    // }
    param = Object.assign({}, param, {
      access_token: window.localStorage.getItem('access_token')
    })
    return axios({
      method: 'post',
      url: baseURL + url,
      data: param,
      timeout: 10000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json; charset=UTF-8'
      }
    }).then((res) => {
      if (res.data && res.data.success) {
        return res.data.resultData
      } else {
        message.warning(res.data.resultMessage)
        closeLoading()
      }
    })
  },
  get (url, params) {
    // 检查并获取本地存储中的 access_token 和 userId
    const userId = window.localStorage.getItem('userId')
    // 将 access_token 和 userId 添加到 params 对象中
    if (userId && (params.userId === null || params.userId === undefined || params.userId === '')) {
      params.userId = userId
    }
    params = Object.assign({}, params, {
      access_token: window.localStorage.getItem('access_token')
    })
    return axios({
      method: 'get',
      url: baseURL + url,
      params, // get 请求时带的参数
      timeout: 10000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(
      (response) => {
        return checkStatus(response)
      }
    )
  },
  getAuth (url, params) {
    // 获取公钥专用
    return axios({
      method: 'get',
      url: url,
      params, // get 请求时带的参数
      timeout: 10000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(
      (response) => {
        return checkStatus(response)
      }
    )
  }
}

function addLoading () {
  store.dispatch('setLoadingState', true)
  loadingCount++
}
function closeLoading () {
  loadingCount--
  if (loadingCount === 0) {
    store.dispatch('setLoadingState', false)
  }
}
